import {Component, Input} from '@angular/core';
import {SubmenuItem} from "../../../interfaces/submenu-item";
import {AnimationItem} from "lottie-web";

@Component({
  selector: 'brt-submenu-item',
  templateUrl: './submenu-item.component.html',
  styleUrls: ['./submenu-item.component.scss']
})
export class SubmenuItemComponent {

  @Input('data') set setData(val: SubmenuItem) {
    this.data = val;
    this.setIconType(this.data.iconUrl);

    this.isUnavailable = val.tags.findIndex((tag) => {
      return tag.title.indexOf("Demnächst") !== -1
    }) !== -1;
  }
  @Input("link") link: string = "#";
  @Input("icon-url") set setIconUrl(value: string) {
    this.iconUrl = value;
    this.setIconType(this.iconUrl);

  }
  @Input("title") title: string = "";
  @Input("abstract") abstract: string = "";
  @Input("target") target: string = "_self";

  @Input("canFocus") canFocus = false;

  data?: SubmenuItem;
  iconType: "img" | "lottie" = "img";
  iconUrl: string = "";

  isUnavailable = false;

  animationItem?: AnimationItem;


  setIconType(path: string) {
    if(path.indexOf(".json") !== -1) {
      this.iconType = "lottie";
    } else {
      this.iconType = "img";
    }
  }

  onAnimationCreated($event: AnimationItem) {
    this.animationItem = $event;
  }

  onMouseEnterEvent() {
    if(this.animationItem) {
      this.animationItem.play();

      const that = this;
      this.animationItem.addEventListener("complete", function eventListener() {
        that.animationItem?.goToAndStop(0);
        that.animationItem?.removeEventListener("complete", eventListener);
      });
    }
  }

  onMouseLeaveEvent() {
    // if(this.animationItem) {
    //   this.animationItem.stop();
    // }
  }

  onItemClicked() {
    if(!this.isUnavailable) {
      if(this.data?.clickCallback) {
        this.data.clickCallback();
      }
    }
  }
}
